(() => {
  function initProduct(root) {
    if (!root || root.dataset.pvPdpReady) return;
    root.dataset.pvPdpReady = 'true';

    const variants = JSON.parse(root.querySelector('[data-pv-pdp-variants]')?.textContent || '[]');
    const groups = [...root.querySelectorAll('[data-pv-pdp-option]')];
    const input = root.querySelector('[data-pv-pdp-variant-input]');
    const priceEl = root.querySelector('[data-pv-pdp-price]');
    const compareEl = root.querySelector('[data-pv-pdp-compare]');
    const saleBadge = root.querySelector('[data-pv-pdp-sale-badge]');
    const salePctEl = root.querySelector('[data-pv-pdp-sale-pct]');
    const saleSaveWrap = root.querySelector('[data-pv-pdp-sale-save]');
    const saleSaveAmt = root.querySelector('[data-pv-pdp-sale-save-amt]');
    const atc = root.querySelector('[data-pv-pdp-atc]');
    const atcLabel = root.querySelector('[data-pv-pdp-atc-label]');
    const sticky = root.querySelector('[data-pv-pdp-sticky]');
    const stickyAtc = root.querySelector('[data-pv-pdp-sticky-atc]');
    const stickyPrice = root.querySelector('[data-pv-pdp-sticky-price]');
    const slides = root.querySelector('[data-pv-pdp-slides]');
    const thumbs = [...root.querySelectorAll('[data-pv-pdp-thumb]')];
    const dots = [...root.querySelectorAll('.pv-ord-pdp__dot')];
    const soldOutText = atcLabel && !atc.disabled ? 'Sold out' : atcLabel?.textContent.trim() || 'Sold out';
    const volumeRoot = root.querySelector('[data-pv-pdp-volume]');
    const moneyFormat = volumeRoot?.dataset.moneyFormat || '${{amount}}';
    const qtyInput = root.querySelector('.pv-ord-pdp__qty-input');
    const qtyMinus = root.querySelector('[data-pv-pdp-qty="-1"]');
    const volumeTiers = [...root.querySelectorAll('[data-pv-pdp-volume-qty]')];
    const volumeNote = root.querySelector('[data-pv-pdp-volume-note]');

    const formatMoney = (cents) => {
      const value = (Math.max(0, cents) / 100).toFixed(2);
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, moneyFormat);
      if (moneyFormat.includes('{{amount}}')) {
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, value);
      }
      return `$${value}`;
    };

    const selected = () => groups.map((group) => group.querySelector('.is-selected')?.dataset.value);

    const findVariant = (options) =>
      variants.find((variant) => variant.options.every((value, index) => value === options[index]));

    const setActiveSlide = (index) => {
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    const goToSlide = (index, smooth = true) => {
      if (!slides) return;
      setActiveSlide(index);
      slides.scrollTo({ left: slides.clientWidth * index, behavior: smooth ? 'smooth' : 'instant' });
    };

    const markAvailability = () => {
      const current = selected();
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('.pv-ord-pdp__pill').forEach((pill) => {
          const options = [...current];
          options[groupIndex] = pill.dataset.value;
          const match = findVariant(options);
          pill.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    };

    const refreshVolumeDollars = (unitCents) => {
      volumeTiers.forEach((tier) => {
        const dollars = tier.querySelector('[data-pv-pdp-volume-dollars]');
        if (!dollars) return;
        const qty = Number(tier.dataset.pvPdpVolumeQty);
        const pct = Number(tier.dataset.pvPdpVolumePct);
        const save = Math.round((unitCents * qty * pct) / 100);
        dollars.textContent = `Save ${formatMoney(save)}`;
      });
    };

    const syncVolume = () => {
      if (!qtyInput) return;
      const value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      let active = null;
      volumeTiers.forEach((tier) => {
        const qty = Number(tier.dataset.pvPdpVolumeQty);
        const on = value >= qty;
        if (on && (!active || qty > Number(active.dataset.pvPdpVolumeQty))) active = tier;
      });
      volumeTiers.forEach((tier) => {
        const isActive = tier === active;
        tier.classList.toggle('is-active', isActive);
        tier.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      if (volumeNote) {
        if (active) {
          const unit = Number(volumeRoot?.dataset.unitPrice || 0);
          const qty = Number(active.dataset.pvPdpVolumeQty);
          const pct = Number(active.dataset.pvPdpVolumePct);
          const save = Math.round((unit * qty * pct) / 100);
          volumeNote.hidden = false;
          volumeNote.innerHTML = `<strong>You're saving ${formatMoney(save)}</strong> — ${pct}% off applies at checkout on ${qty}+`;
        } else {
          volumeNote.hidden = true;
          volumeNote.textContent = '';
        }
      }
    };

    const syncQty = () => {
      if (!qtyInput) return;
      const value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = value;
      if (qtyMinus) qtyMinus.disabled = value <= 1;
      syncVolume();
    };

    const applyVariant = (variant) => {
      if (!variant) return;
      input.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (compareEl) {
        compareEl.hidden = !variant.compare;
        compareEl.textContent = variant.compare || '';
      }
      const onSale = variant.compare_cents && variant.compare_cents > variant.price_cents;
      if (saleBadge) saleBadge.hidden = !onSale;
      if (saleSaveWrap) saleSaveWrap.hidden = !onSale;
      if (onSale) {
        const saveCents = variant.compare_cents - variant.price_cents;
        const pct = Math.round((saveCents / variant.compare_cents) * 100);
        if (salePctEl) salePctEl.textContent = `${pct}% OFF`;
        if (saleSaveAmt) saleSaveAmt.textContent = formatMoney(saveCents);
      }
      if (volumeRoot && variant.price_cents) {
        volumeRoot.dataset.unitPrice = String(variant.price_cents);
        refreshVolumeDollars(variant.price_cents);
      }
      const label = variant.available ? 'Add to Cart' : soldOutText;
      if (atc) {
        atc.disabled = !variant.available;
        atc.removeAttribute('aria-disabled');
      }
      if (atcLabel) atcLabel.textContent = label;
      if (stickyAtc) {
        stickyAtc.disabled = !variant.available;
        stickyAtc.textContent = label;
      }
      if (variant.media && slides) {
        const index = [...slides.children].findIndex((slide) => slide.dataset.mediaId === String(variant.media));
        if (index >= 0) goToSlide(index);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      markAvailability();
      syncVolume();
    };

    groups.forEach((group, groupIndex) => {
      group.addEventListener('click', (event) => {
        const pill = event.target.closest('.pv-ord-pdp__pill');
        if (!pill || pill.classList.contains('is-selected')) return;
        group.querySelectorAll('.pv-ord-pdp__pill').forEach((p) => {
          p.classList.toggle('is-selected', p === pill);
          p.setAttribute('aria-checked', p === pill ? 'true' : 'false');
        });

        let variant = findVariant(selected());
        if (!variant) {
          variant =
            variants.find((v) => v.options[groupIndex] === pill.dataset.value && v.available) ||
            variants.find((v) => v.options[groupIndex] === pill.dataset.value);
          if (variant) {
            groups.forEach((g, i) => {
              g.querySelectorAll('.pv-ord-pdp__pill').forEach((p) => {
                const on = p.dataset.value === variant.options[i];
                p.classList.toggle('is-selected', on);
                p.setAttribute('aria-checked', on ? 'true' : 'false');
              });
            });
          }
        }
        applyVariant(variant);
      });
    });

    if (groups.length) markAvailability();

    const initial = variants.find((variant) => String(variant.id) === input?.value);
    if (initial?.media && slides) {
      const index = [...slides.children].findIndex((slide) => slide.dataset.mediaId === String(initial.media));
      if (index > 0) {
        requestAnimationFrame(() => goToSlide(index, false));
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goToSlide(Number(thumb.dataset.pvPdpThumb)));
    });

    if (slides) {
      let frame;
      slides.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            setActiveSlide(Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1)));
          });
        },
        { passive: true }
      );
      slides.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        const current = Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
        const next = Math.min(Math.max(current + (event.key === 'ArrowRight' ? 1 : -1), 0), slides.children.length - 1);
        goToSlide(next);
        event.preventDefault();
      });
    }

    root.querySelectorAll('[data-pv-pdp-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + Number(btn.dataset.pvPdpQty);
        syncQty();
      });
    });
    qtyInput?.addEventListener('change', syncQty);
    qtyInput?.addEventListener('input', syncQty);
    volumeTiers.forEach((tier) => {
      tier.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = Number(tier.dataset.pvPdpVolumeQty);
        syncQty();
      });
    });
    if (qtyInput) syncQty();

    const buyRow = root.querySelector('[data-pv-pdp-buy-row]');
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyAtc) stickyAtc.tabIndex = show ? 0 : -1;
      }).observe(buyRow);
    }
  }

  document.querySelectorAll('[data-pv-pdp]').forEach(initProduct);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-pv-pdp]').forEach(initProduct);
  });
})();
